import React from "react";
import "./Table.css";

const Table = ({ title, data, columns ,priority}) => {
  return (
    <div className="tableContainer">
      {title && <h3>{title}</h3>}

      {/* Table for desktop */}
      <table className="notification-table">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className={row.priority > 1 ? 'priority' : ''}>
              {columns.map((col, colIndex) => (
                <td key={colIndex}>
                  {col.render ? col.render(row[col.accessor], row) : row[col.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    {/* Cards for mobile */}
<div className="notification-cards">
  {data.map((row, rowIndex) => (
    <div
    className={`notification-card ${row.priority > 1 ? 'priority' : ''}`}
    key={rowIndex}
  >
    {/* {console.log("row",row)}
    {console.log("columns",columns)} */}
      <div className="notification-card-content">
        <div className="notification-card-message">
          {columns.find(col => col.accessor === "payload.quoteType")?.render(row["payload.quoteType"], row)}
        </div>
      </div>

      <div className="notification-card-date">
      {columns.find(col => col.accessor === "formattedUpdateDate")?.render?.(row["formattedUpdateDate"], row)}
      </div>

      <div className="notification-card-action">
      {columns.find(col => col.accessor === "action")?.render?.(row["action"], row)}
      </div>
    </div>
  ))}
</div>


    </div>
  );
};

export default Table;
